import { z } from 'zod';

export const LookupKind = z.enum([
  'brand',
  'inventory_type',
  'tag',
  'part_category',
  'product_category',
]);
export type LookupKind = z.infer<typeof LookupKind>;

// Tags only: whether a tag is a promotion ("Harvest Sale") or describes the
// unit ("Comes with hydraulic pump"). Decides the chip colour on the site.
export const TagStyle = z.enum(['promo', 'feature']);
export type TagStyle = z.infer<typeof TagStyle>;

// Tags only: the chip colour, picked per tag (migration 0010). Names, not hex —
// the site owns the exact shades. 'yellow' is the original amber chip.
export const TagColor = z.enum(['yellow', 'orange', 'green', 'blue', 'red']);
export type TagColor = z.infer<typeof TagColor>;

export const Lookup = z.object({
  id: z.number().int().positive(),
  name: z.string().min(1).max(100),
  sort_order: z.number().int().nonnegative().default(0),
  // Present on tags, absent on every other lookup kind.
  style: TagStyle.optional(),
  color: TagColor.optional(),
});
export type Lookup = z.infer<typeof Lookup>;

export const LookupInput = z.object({
  // .trim() must come BEFORE .min(1): it is a transform, not a check, so
  // `.min(1).trim()` validated the untrimmed string and then trimmed it —
  // "   " passed the length check and was stored as an empty name.
  name: z.string().trim().min(1).max(100),
  sort_order: z.number().int().nonnegative().optional(),
  // Tags only; ignored for other kinds. Omitted on update = leave as is.
  style: TagStyle.optional(),
  color: TagColor.optional(),
});
export type LookupInput = z.infer<typeof LookupInput>;
